/**
 * Get Invoice Attachment Use Case
 *
 * Business logic for getting invoice attachment following clean architecture principles.
 */

import {SalesDashboardRepository} from '../repository/SalesDashboardRepository';
import {InvoiceAttachmentDTO} from '../api/SalesDashboardAPIDataSource';

export class GetInvoiceAttachmentUseCase {
  constructor (private repository: SalesDashboardRepository) {}

  async execute (invoiceId: string | number): Promise<InvoiceAttachmentDTO | null> {
    return await this.repository.getInvoiceAttachment(invoiceId);
  }
}
